const c = function (t, n) {
  let r = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 0;
  var e;
  if (!((e = n == null ? void 0 : n.current) != null && e.offsetWidth)) return t.length;
  const l = n.current.offsetWidth;
  return t.filter(u => u + r <= l).length;
};
export { c as calculateInnerElements };